(function () {
  const CONFIG = {
    shopifyDomain: "g10dn4-0k.myshopify.com",
    storefrontToken: "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",
    groqKey: "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",
    groqModel: "llama-3.3-70b-versatile",
    botName: "Conseil Carrelage",
    primaryColor: "#8B4A1E",
    accentColor: "#C17F3E",
    bgColor: "#FAF7F2",
  };

  const style = document.createElement("style");
  style.textContent = `
    #cc-fab {
      position:fixed;bottom:24px;right:24px;z-index:9999;
      width:58px;height:58px;border-radius:50%;
      background:${CONFIG.primaryColor};border:none;cursor:pointer;
      box-shadow:0 4px 20px rgba(61,43,31,0.28);
      display:flex;align-items:center;justify-content:center;
      transition:background 0.2s,transform 0.2s;
    }
    #cc-fab:hover{background:${CONFIG.accentColor};transform:scale(1.05);}
    #cc-fab svg{width:26px;height:26px;fill:none;stroke:#FAF7F2;stroke-width:1.8;}
    #cc-badge{
      position:absolute;top:-2px;right:-2px;
      width:18px;height:18px;border-radius:50%;
      background:#C0392B;color:white;font-size:10px;
      display:flex;align-items:center;justify-content:center;
      font-family:sans-serif;font-weight:600;border:2px solid white;
    }
    #cc-window{
      position:fixed;bottom:94px;right:24px;z-index:9998;
      width:370px;max-height:560px;
      background:${CONFIG.bgColor};
      border-radius:20px 20px 4px 20px;
      box-shadow:0 8px 40px rgba(61,43,31,0.18);
      border:0.5px solid rgba(193,127,62,0.3);
      display:flex;flex-direction:column;
      font-family:'Segoe UI',system-ui,sans-serif;
      overflow:hidden;transition:opacity 0.2s,transform 0.2s;
    }
    #cc-window.cc-hidden{opacity:0;transform:translateY(12px) scale(0.97);pointer-events:none;}
    #cc-header{
      background:${CONFIG.primaryColor};padding:13px 16px;
      display:flex;align-items:center;gap:10px;flex-shrink:0;
    }
    #cc-avatar{
      width:36px;height:36px;border-radius:50%;
      background:${CONFIG.accentColor};
      display:flex;align-items:center;justify-content:center;
      font-size:15px;color:#FAF7F2;font-weight:600;
    }
    #cc-header-info{flex:1;}
    #cc-header-name{color:#FAF7F2;font-size:15px;font-weight:600;}
    #cc-header-status{color:rgba(242,232,217,0.7);font-size:11px;}
    #cc-close-btn{
      background:rgba(255,255,255,0.12);border:none;cursor:pointer;
      width:28px;height:28px;border-radius:50%;
      display:flex;align-items:center;justify-content:center;
      color:rgba(242,232,217,0.8);font-size:18px;line-height:1;
      transition:background 0.15s;
    }
    #cc-close-btn:hover{background:rgba(255,255,255,0.2);}
    #cc-messages{
      flex:1;overflow-y:auto;padding:14px 12px;
      display:flex;flex-direction:column;gap:10px;
      scrollbar-width:thin;scrollbar-color:rgba(193,127,62,0.2) transparent;
    }
    .cc-msg{display:flex;flex-direction:column;gap:3px;max-width:90%;}
    .cc-msg.cc-bot{align-self:flex-start;}
    .cc-msg.cc-user{align-self:flex-end;}
    .cc-bubble{padding:10px 13px;border-radius:16px;font-size:13.5px;line-height:1.55;}
    .cc-bot .cc-bubble{background:#EDE0CE;color:#3D2B1F;border-radius:4px 16px 16px 16px;}
    .cc-user .cc-bubble{background:${CONFIG.primaryColor};color:#FAF7F2;border-radius:16px 4px 16px 16px;}
    .cc-chips{display:flex;flex-wrap:wrap;gap:6px;margin-top:2px;}
    .cc-chip{
      padding:5px 11px;border-radius:20px;font-size:12px;
      cursor:pointer;border:0.5px solid rgba(193,127,62,0.45);
      background:transparent;color:#6B5E52;
      transition:all 0.15s;font-family:inherit;
    }
    .cc-chip:hover{background:${CONFIG.accentColor};color:#FAF7F2;border-color:${CONFIG.accentColor};}
    .cc-products{display:flex;gap:8px;overflow-x:auto;padding:2px 0;scrollbar-width:none;}
    .cc-product-card{
      min-width:108px;background:#FAF7F2;
      border:0.5px solid rgba(193,127,62,0.35);
      border-radius:12px;overflow:hidden;flex-shrink:0;
      cursor:pointer;text-decoration:none;transition:border-color 0.15s;
    }
    .cc-product-card:hover{border-color:${CONFIG.accentColor};}
    .cc-product-img{width:100%;height:62px;object-fit:cover;background:#EDE0CE;}
    .cc-product-body{padding:7px 8px;}
    .cc-product-name{font-size:11px;font-weight:600;color:#3D2B1F;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
    .cc-product-meta{font-size:10px;color:#6B5E52;margin-top:1px;}
    .cc-product-price{font-size:11px;font-weight:600;color:${CONFIG.accentColor};margin-top:3px;}
    .cc-typing{
      display:flex;gap:5px;align-items:center;
      padding:10px 14px;background:#EDE0CE;
      border-radius:4px 16px 16px 16px;width:fit-content;
    }
    .cc-dot{width:6px;height:6px;border-radius:50%;background:#6B5E52;animation:cc-bounce 1.2s infinite;}
    .cc-dot:nth-child(2){animation-delay:0.2s;}
    .cc-dot:nth-child(3){animation-delay:0.4s;}
    @keyframes cc-bounce{0%,60%,100%{transform:translateY(0);opacity:0.4;}30%{transform:translateY(-4px);opacity:1;}}
    #cc-input-area{
      padding:10px 12px 13px;border-top:0.5px solid rgba(193,127,62,0.2);
      display:flex;gap:8px;align-items:flex-end;
      background:${CONFIG.bgColor};flex-shrink:0;
    }
    #cc-input{
      flex:1;background:#EDE0CE;border:none;
      border-radius:20px;padding:9px 14px;
      font-size:13px;font-family:inherit;color:#3D2B1F;
      outline:none;resize:none;min-height:36px;max-height:90px;
    }
    #cc-input::placeholder{color:rgba(107,94,82,0.5);}
    #cc-send-btn{
      width:36px;height:36px;border-radius:50%;
      background:${CONFIG.primaryColor};border:none;cursor:pointer;
      display:flex;align-items:center;justify-content:center;
      flex-shrink:0;color:#FAF7F2;transition:background 0.15s;
    }
    #cc-send-btn:hover{background:${CONFIG.accentColor};}
    #cc-send-btn svg{width:16px;height:16px;fill:none;stroke:#FAF7F2;stroke-width:2;}
  `;
  document.head.appendChild(style);

  document.body.insertAdjacentHTML("beforeend", `
    <button id="cc-fab" aria-label="Ouvrir le conseiller carrelage">
      <svg viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
      <span id="cc-badge">1</span>
    </button>
    <div id="cc-window" class="cc-hidden" role="dialog" aria-label="Conseiller carrelage">
      <div id="cc-header">
        <div id="cc-avatar">C</div>
        <div id="cc-header-info">
          <div id="cc-header-name">${CONFIG.botName}</div>
          <div id="cc-header-status">● En ligne · répond en quelques secondes</div>
        </div>
        <button id="cc-close-btn" aria-label="Fermer">×</button>
      </div>
      <div id="cc-messages"></div>
      <div id="cc-input-area">
        <textarea id="cc-input" placeholder="Ex : carrelage blanc mat 60×60…" rows="1"></textarea>
        <button id="cc-send-btn" aria-label="Envoyer">
          <svg viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
        </button>
      </div>
    </div>
  `);

  let isOpen = false;
  let isLoading = false;
  let products = [];
  let conversationHistory = [];

  async function loadProducts() {
    try {
      const query = `{
        products(first:100) {
          edges { node {
            id title handle
            description(truncateAt:200)
            priceRange { minVariantPrice { amount currencyCode } }
            images(first:1) { edges { node { url altText } } }
            tags
            variants(first:10) {
              edges { node {
                title
                selectedOptions { name value }
                price { amount }
              }}
            }
          }}
        }
      }`;
      const res = await fetch(`https://${CONFIG.shopifyDomain}/api/2024-01/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": CONFIG.storefrontToken,
        },
        body: JSON.stringify({ query }),
      });
      const data = await res.json();
      products = (data.data?.products?.edges || []).map(e => e.node);
      console.log(`Chatbot: ${products.length} produits chargés`, products.slice(0,2));
    } catch (err) {
      console.warn("Chatbot: impossible de charger les produits", err.message, err);
    }
  }

  function buildProductContext() {
    if (!products.length) return "Catalogue non disponible pour le moment.";
    return products.slice(0, 60).map(p => {
      const price = p.priceRange?.minVariantPrice?.amount;
      const variants = p.variants.edges
        .map(v => v.node.selectedOptions.map(o => `${o.name}: ${o.value}`).join(", "))
        .join(" | ");
      return `- ${p.title} | ${p.description || ""} | Tags: ${p.tags.join(", ")} | Variantes: ${variants} | Prix: ${price} EUR | URL: https://monarchitecte.fr/products/${p.handle}`;
    }).join("\n");
  }

  async function askGroq(userMessage) {
    const productContext = buildProductContext();
    const systemPrompt = `Tu es un expert conseiller en carrelage céramique pour la boutique monarchitecte.fr.
Tu connais parfaitement :
- Les types : grès cérame, faïence, pierre naturelle, mosaïque, béton ciré
- Les formats : 20x20, 30x30, 30x60, 45x45, 60x60, 60x120, 80x80, 120x120 et lames
- Les finitions : mat, brillant, satiné, poli, structuré, imitation bois/béton/pierre
- Les épaisseurs : 6mm (mur), 9mm (sol intérieur), 11mm (sol intensif), 18-20mm (extérieur)
- Les classements antidérapants R9 à R13
- La résistance PEI 1 à 5
- Les usages : salle de bain, cuisine, séjour, chambre, terrasse, piscine, commerce

Catalogue actuel :
${productContext}

Règles :
- Recommande des produits du catalogue quand c'est pertinent, cite leur nom et URL
- Réponds en français, de façon chaleureuse et professionnelle
- Sois concis (3-5 phrases) sauf question technique
- Termine toujours par une suggestion de suivi`;

    conversationHistory.push({ role: "user", content: userMessage });

    const res = await fetch("https://api.groq.com/openai/v1/chat/completions", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${CONFIG.groqKey}`,
      },
      body: JSON.stringify({
        model: CONFIG.groqModel,
        max_tokens: 600,
        messages: [
          { role: "system", content: systemPrompt },
          ...conversationHistory,
        ],
      }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      console.error("Groq error:", err);
      throw new Error(err.error?.message || "Erreur API Groq");
    }

    const data = await res.json();
    const reply = data.choices?.[0]?.message?.content || "Désolé, je n'ai pas pu répondre.";
    conversationHistory.push({ role: "assistant", content: reply });
    return reply;
  }

  function extractMentionedProducts(aiText) {
    return products.filter(p =>
      aiText.toLowerCase().includes(p.title.toLowerCase()) ||
      (p.handle && aiText.toLowerCase().includes(p.handle.toLowerCase()))
    ).slice(0, 4);
  }

  const messagesEl = document.getElementById("cc-messages");

  function addMessage(html, type) {
    const div = document.createElement("div");
    div.className = `cc-msg cc-${type}`;
    div.innerHTML = `<div class="cc-bubble">${html}</div>`;
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return div;
  }

  function addChips(items) {
    const div = document.createElement("div");
    div.className = "cc-msg cc-bot";
    div.innerHTML = `<div class="cc-chips">${items.map(t => `<button class="cc-chip">${t}</button>`).join("")}</div>`;
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    div.querySelectorAll(".cc-chip").forEach(btn => {
      btn.addEventListener("click", () => handleSend(btn.textContent));
    });
  }

  function addProductCards(prods) {
    if (!prods.length) return;
    const div = document.createElement("div");
    div.className = "cc-msg cc-bot";
    div.innerHTML = `<div class="cc-products">${prods.map(p => {
      const img = p.images?.edges?.[0]?.node?.url || "";
      const price = p.priceRange?.minVariantPrice?.amount;
      const imgHtml = img
        ? `<img class="cc-product-img" src="${img}" alt="${p.title}" loading="lazy">`
        : `<div class="cc-product-img"></div>`;
      return `<a class="cc-product-card" href="https://monarchitecte.fr/products/${p.handle}" target="_blank">
        ${imgHtml}
        <div class="cc-product-body">
          <div class="cc-product-name">${p.title}</div>
          <div class="cc-product-meta">${p.tags.slice(0,2).join(" · ")}</div>
          ${price ? `<div class="cc-product-price">${parseFloat(price).toFixed(2)} €</div>` : ""}
        </div>
      </a>`;
    }).join("")}</div>`;
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function showTyping() {
    const div = document.createElement("div");
    div.className = "cc-msg cc-bot";
    div.id = "cc-typing";
    div.innerHTML = `<div class="cc-typing"><div class="cc-dot"></div><div class="cc-dot"></div><div class="cc-dot"></div></div>`;
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return div;
  }

  function showWelcome() {
    addMessage(
      "Bonjour ! Je suis votre conseiller carrelage. Je connais tout le catalogue de <strong>monarchitecte.fr</strong>.<br><br>Dites-moi votre projet et je vous recommande les produits parfaits.",
      "bot"
    );
    addChips(["Salle de bain", "Cuisine", "Terrasse", "Grand format", "Carrelage blanc mat", "Imitation bois"]);
  }

  async function handleSend(text) {
    if (isLoading) return;
    const input = document.getElementById("cc-input");
    const msg = text || input.value.trim();
    if (!msg) return;
    input.value = "";

    addMessage(msg, "user");
    const typingEl = showTyping();
    isLoading = true;

    try {
      const reply = await askGroq(msg);
      typingEl.remove();
      addMessage(reply.replace(/\n/g, "<br>"), "bot");
      addProductCards(extractMentionedProducts(reply));
    } catch (err) {
      typingEl.remove();
      console.error("Chatbot erreur:", err);
      addMessage(`Désolé, une erreur est survenue : ${err.message}`, "bot");
    }
    isLoading = false;
  }

  function openChat() {
    isOpen = true;
    document.getElementById("cc-window").classList.remove("cc-hidden");
    document.getElementById("cc-badge").style.display = "none";
    document.getElementById("cc-input").focus();
    if (!messagesEl.children.length) showWelcome();
  }

  function closeChat() {
    isOpen = false;
    document.getElementById("cc-window").classList.add("cc-hidden");
  }

  document.getElementById("cc-fab").addEventListener("click", () => isOpen ? closeChat() : openChat());
  document.getElementById("cc-close-btn").addEventListener("click", closeChat);
  document.getElementById("cc-send-btn").addEventListener("click", () => handleSend());
  document.getElementById("cc-input").addEventListener("keydown", e => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSend(); }
  });

  console.log("Chatbot: démarrage, domaine =", CONFIG.shopifyDomain);
  loadProducts();
})();
